import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navbar.css';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setMobileDropdown(false);
  };
  const toggleMobileDropdown = () => setMobileDropdown(!mobileDropdown);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          TA2GBO <i className="fas fa-broadcast-tower"></i>
        </Link>
        <div className="menu-icon" onClick={toggleMobileMenu}>
          <i className={isMobileMenuOpen ? 'fas fa-times' : 'fas fa-bars'} />
        </div>
        <div className={isMobileMenuOpen ? 'nav-right-section active' : 'nav-right-section'}>
          <ul className="nav-menu">
            <li className="nav-item"><Link to="/" className="nav-links" onClick={closeMobileMenu}>{t('navbar.home')}</Link></li>
            <li className="nav-item dropdown">
              <span className="nav-links" style={{cursor: 'pointer'}} onClick={toggleMobileDropdown}>
                {t('navbar.me')} <i className={`fas fa-caret-${mobileDropdown ? 'up' : 'down'}`} style={{marginLeft: '5px'}}></i>
              </span>
              <ul className={mobileDropdown ? "dropdown-menu active" : "dropdown-menu"}>
                <li><Link to="/hakkimda" className="dropdown-link" onClick={closeMobileMenu}>{t('navbar.about')}</Link></li>
                <li><Link to="/ekipmanlar" className="dropdown-link" onClick={closeMobileMenu}>{t('navbar.equipment')}</Link></li>
                <li><Link to="/map" className="dropdown-link" onClick={closeMobileMenu}>{t('navbar.map')}</Link></li>
              </ul>
            </li>
            <li className="nav-item"><Link to="/blog" className="nav-links" onClick={closeMobileMenu}>{t('navbar.blog')}</Link></li>
            <li className="nav-item"><Link to="/calculators" className="nav-links" onClick={closeMobileMenu}>{t('navbar.calculators')}</Link></li>
            <li className="nav-item"><Link to="/iletisim" className="nav-links" onClick={closeMobileMenu}>{t('navbar.contact')}</Link></li>
          </ul>
          <div className="lang-switch">
            <button onClick={() => changeLanguage('tr')} className={i18n.language.startsWith('tr') ? 'active' : ''}>TR</button>
            <button onClick={() => changeLanguage('en')} className={i18n.language.startsWith('en') ? 'active' : ''}>EN</button>
            <button onClick={() => changeLanguage('de')} className={i18n.language.startsWith('de') ? 'active' : ''}>DE</button>
            <button onClick={() => changeLanguage('es')} className={i18n.language.startsWith('es') ? 'active' : ''}>ES</button>
          <button onClick={() => changeLanguage('fr')} className={i18n.language.startsWith('fr') ? 'active' : ''}>FR</button>
          <button onClick={() => changeLanguage('ru')} className={i18n.language.startsWith('ru') ? 'active' : ''}>RU</button>
        
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;